<script setup lang="ts">
    import '../../../css/choice.css';
    import ModalDialog from "../../components/ModalDialog.vue";
    import {ActionButtonStyle,billingBaseClass} from '../../lib/Types/Types';
    import {ButtonDisplaySize,ButtonDisplayStyle,ModalSize,TextInputType,UserPinType} from '../../Enums/UiEnums';
    import ActionButtonV2 from '../../components/ActionButtonV2.vue'; 
    import IntegerInput from '../../components/IntegerInput.vue';
    import * as ChoiceApi from '../../lib/ChoiceApi';
    import { currentChoiceUser } from '../../lib/ChoiceUtils';
    import { SimpleUserInfoModel } from '../../lib/Models/User/SimpleUserInfoModel';
    import { onMounted,reactive,watch } from 'vue'; 
    import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';

    const formData = reactive <
    {   
        currentAppUser?: SimpleUserInfoModel
        pin: {value?: number, validated: boolean, message : string},
        displayPin: boolean

    }>({   
        pin: {value: 0, validated: false, message : ""},
        displayPin: false
    });
    const props = withDefaults(defineProps<{
            show: boolean,
            pinType: UserPinType
        }>(), {
            show: false,
            pinType: UserPinType.Signoff
    });
    onMounted(async () => {
        const currentUserId = currentChoiceUser() ?? "N/A";
        formData.currentAppUser = (await ChoiceApi.user.SimpleInfoByIdType(DatabaseIdTypes.user_id, currentUserId));
    });   
    const emit = defineEmits<{
        (e: "closePin", pin_validated: boolean): void
    }>();

    watch(() => props.show, (newValue, oldValue) => { 
        formData.displayPin = newValue; 
        formData.pin = {value: undefined, validated : false, message: ""};
    }); 
    async function cancelProcess() : Promise<void>  { 
        formData.pin = {value: undefined, validated : false, message: ""};
        formData.displayPin = false; 
    }  
    async function checkPin() : Promise<void>  {  
        if ((formData.pin.value ?? 0) === 0) {
            formData.pin.message = "Invalid Pin";
            formData.pin.validated = false;
            return;
        } 
        const pinValidation = (await ChoiceApi.user.ValidateUserPin(formData.pin.value ?? 0));
        formData.pin.validated = (pinValidation.isValidPin === 1 ? true : false);
        formData.pin.message = (formData.pin.validated ? "" : "Invalid Pin");
        if (formData.pin.validated) {
            formData.displayPin = false; 
        }
    }  
    async function validatePin() : Promise<void>  { 
        emit("closePin",formData.pin.validated); 
    }  
    function resetErrorMessage() : void {
        formData.pin.message = "";
    }
</script>
<template> 
    <ModalDialog :size=ModalSize.Small :show="formData.displayPin" :closeOnClickOutside="false" @hide="validatePin"> 
        <template v-slot:title>Enter {{$props.pinType}} PIN</template>
        <template #footer>
            <ActionButtonV2 
                :action="ActionButtonStyle.Check"  
                :text="'OK'"  
                :tooltip="'Validate Prescription PIN.'"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary"
                :performAction="checkPin" />
            <ActionButtonV2 
                :action="ActionButtonStyle.Close"  
                :text="'Cancel'"  
                :tooltip="'Cancel Prescription Send Process, prescriptions will be left in the status as you see them now.'"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary"
                :performAction="cancelProcess" />
        </template> 
        <div class="row"> 
            <div class="col text-start"> 
                <table style="table-layout: fixed;">
                    <colgroup>
                        <col style="width: 3rem;">
                        <col style="width: 4rem;">
                        <col style="width: 100%;">
                    </colgroup>
                    <tr>
                        <td rowspan=4 class="pe-3">
                            <em class="fa-solid fa-key text-isalus-primary" style="font-size: 3rem;"></em>
                        </td>
                        <td class="label-isalus-small text-isalus-primary pe-3">User:</td>
                        <td class="label-isalus-small pe-3">{{formData.currentAppUser?.users_id}}</Td>
                    </tr>
                    <tr>
                        <td class="label-isalus-small text-isalus-primary pe-3">Name:</td>
                        <td class="label-isalus-small pe-3">{{formData.currentAppUser?.first_name}} {{formData.currentAppUser?.last_name}}</Td>
                    </tr>
                    <tr>
                        <td class="label-isalus-small text-isalus-primary pe-3">Pin:</td>
                        <td style="width: 5rem;">
                            <IntegerInput  
                                v-model:numberValue="formData.pin.value" 
                                :inputType="TextInputType.password"
                                placeholder="Rx Pin" 
                                :maxLength="4"
                                :cssFramework = "'vanilla'"
                                @update:numberValue="resetErrorMessage"/>
                        </td>
                    </tr>
                    <tr> 
                        <td colspan="2">
                            <div v-show="formData.pin.message !== ''" class="label-isalus-small text-danger ps-3">{{formData.pin.message}}</div>
                        </td>
                    </tr> 
                </table>    
            </div>
        </div>
    </ModalDialog>
</template>